import { render, staticRenderFns } from "./CarboneServersTable.vue?vue&type=template&id=fb3b5590&"
import script from "./CarboneServersTable.vue?vue&type=script&lang=js&"
export * from "./CarboneServersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports